import { ButtonAddProject } from "components/buttons";
import {
  InputSearchProject,
  InputProjectType,
  ProjectCardsList,
  InputProjectOrderBy,
} from "./components";
import { HeaderMainContent, HeaderTableContent } from "components/shared";
import { labelProjects } from "_constants";

export const ProjectsPage = () => {
  return (
    <>
      <HeaderMainContent child={<ButtonAddProject />} label={labelProjects} />
      <HeaderTableContent
        child={
          <>
            <InputSearchProject />
            <InputProjectType />
            <InputProjectOrderBy />
          </>
        }
        colNumber={3}
      />
      <ProjectCardsList />
    </>
  );
};
